/**
 * End-date "same as start" linking for DateTime v2 dateTime end fields.
 * Registers window.checkUseStartDate{endInputId} for HourlyEditAlert and similar callers.
 */
function tsDt2InitLinkedEndDate(cfg) {
	var endInputId = cfg.endInputId;
	var startInputId = cfg.startInputId;
	var endInputName = cfg.endInputName;
	var hideWhenLinked = !!cfg.hideWhenLinked;
	var sameAsLabel = cfg.sameAsLabel || '';
	var useLabel = cfg.useLabel || '';
	var calendarOnChangeJs = cfg.calendarOnChangeJs || '';

	// Hide/show the date picker end date - no longer used! But kept just in case we revert from setEndDatePickerDisabled!
	function setEndDatePickerHidden(hidden) {
		$('#' + endInputName + 'Div')
			.closest('.ts-dt2-date-mount')
			.toggleClass('ts-dt2-date-mount--hidden', !!hidden);
	}

	/**
	 * Disable the end date picker when Same date is selected
	 * @param {boolean} disabled
	 */
	function setEndDatePickerDisabled(disabled) {
		$(".dateOverlay").remove();
		if($("#UseStartDate").prop("checked")){
			let arrows = $("#arrowControls"+endInputId);
			arrows.parent().append('<div class="dateOverlay"></div>');
		}
	}

	function syncEndDateFromStart() {
		$('#' + endInputId).val($('#' + startInputId).val());
		if (typeof window.tsDp2FitInputWidth === 'function') {
			window.tsDp2FitInputWidth(endInputId);
		}
	}

	function applyLinkedDateVisibility(sameAsStart) {
		if (hideWhenLinked && sameAsStart) {
			setEndDatePickerDisabled(true);
		} else {
			setEndDatePickerDisabled(false);
		}
	}

	function setEndDateFormat(sameAsStart) {
		if (sameAsStart) {
			syncEndDateFromStart();
		}
		applyLinkedDateVisibility(sameAsStart);
	}

	window['checkUseStartDate' + endInputId] = function (checkedOn) {
		$('.ui-effects-transfer').stop(true, true).remove();
		if (!checkedOn) {
			applyLinkedDateVisibility(false);
			if ($('#' + endInputId).hasClass('hasDatepicker')) {
				$('#' + endInputId).datepicker('hide');
			}
			$('#sameAsOrUse').text(useLabel);
			setEndDateFormat(false);
		} else {
			setEndDateFormat(true);
			$('#sameAsOrUse').text(sameAsLabel);
		}
		if (calendarOnChangeJs) {
			try {
				// eslint-disable-next-line no-eval
				eval(calendarOnChangeJs);
			} catch (e) { /* ignore */ }
		}
	};

	$(document).ready(function () {
		if ($('#' + endInputId).val() === $('#' + startInputId).val()) {
			$('#sameAsOrUse').text(sameAsLabel);
			$('#UseStartDate').prop('checked', true);
			setEndDateFormat(true);
		} else {
			applyLinkedDateVisibility(false);
			$('#sameAsOrUse').text(useLabel);
			$('#UseStartDate').prop('checked', false);
			setEndDateFormat(false);
		}
	});
}

window.tsDt2InitLinkedEndDate = window.tsDt2InitLinkedEndDate || tsDt2InitLinkedEndDate;
